export function normalizeRole(role: string | undefined | null): string {
  return (role ?? "").toLowerCase().replace(/[_-]/g, "");
}

/**
 * Who may create, edit or delete organization/location Calls to Action. Mirrors the database helper
 * `can_manage_organization_ctas()` (migration 2026-10-02-080) and the CRM's organization/location edit
 * routes: superadmin, admin, manager, staff, support_admin. Everyone else (support_agent, msr, partner,
 * readonly, finance, concierge …) sees CTAs read-only — the database refuses their writes regardless.
 */
const ORG_CTA_MANAGER_ROLES = new Set([
  "superadmin",
  "admin",
  "manager",
  "staff",
  "supportadmin",
]);
// Regional / Territory Managers: organization / location CTAs are view-only for them in this release (round-4 audit:
// a browser-built CTA link / QR cannot be verified by the server; can_manage_organization_ctas() refuses them too).

export function canManageOrganizationCTAs(
  role: string | undefined | null,
): boolean {
  return ORG_CTA_MANAGER_ROLES.has(normalizeRole(role));
}
